if(typeof FN == 'undefined') FN = {};

FN.architectureDetector = {
  cache: null,
  
  /**
   * Detect the user's processor architecture
   * @returns {Promise<string>} Returns 'arm', 'x86', or 'unknown'
   */
  detect: function() {
    // Return cached result if available
    if (FN.architectureDetector.cache !== null) {
      return Promise.resolve(FN.architectureDetector.cache);
    }
    
    // Try modern API first (Chrome/Edge 90+)
    return FN.architectureDetector.detectModern()
      .then(function(architecture) {
        // If modern method failed, try fallback
        if (architecture === 'unknown') {
          architecture = FN.architectureDetector.detectFromUserAgent();
        }
        
        // Normalize and cache the result
        architecture = FN.architectureDetector.normalizeArchitecture(architecture);
        FN.architectureDetector.cache = architecture;
        
        return architecture;
      })
      .catch(function(error) {
        console.warn('Architecture detection failed, using fallback:', error);
        
        // Use fallback method
        var architecture = FN.architectureDetector.detectFromUserAgent();
        architecture = FN.architectureDetector.normalizeArchitecture(architecture);
        FN.architectureDetector.cache = architecture;
        
        return architecture;
      });
  },
  
  /**
   * Detect architecture using the modern navigator.userAgentData API
   * @returns {Promise<string>} Architecture string or 'unknown'
   */
  detectModern: function() {
    if (!('userAgentData' in navigator) || !navigator.userAgentData.getHighEntropyValues) {
      return Promise.resolve('unknown');
    }
    
    return navigator.userAgentData.getHighEntropyValues(['architecture'])
      .then(function(uaData) {
        return uaData.architecture || 'unknown';
      })
      .catch(function(error) {
        console.warn('Modern architecture detection failed:', error);
        return 'unknown';
      });
  },
  
  /**
   * Detect architecture from user agent string (fallback method)
   * @returns {string} Architecture string or 'unknown'
   */
  detectFromUserAgent: function() {
    var userAgent = navigator.userAgent.toLowerCase();
    
    // Check for ARM indicators
    if (userAgent.indexOf('arm') !== -1 || 
        userAgent.indexOf('aarch64') !== -1 || 
        userAgent.indexOf('apple silicon') !== -1) {
      return 'arm';
    }
    
    // Check for x86/x64 indicators
    if (userAgent.indexOf('x86') !== -1 || 
        userAgent.indexOf('x64') !== -1 || 
        userAgent.indexOf('amd64') !== -1 || 
        userAgent.indexOf('intel') !== -1) {
      return 'x86';
    }
    
    // Additional checks for specific platforms
    if (userAgent.indexOf('mac') !== -1 && userAgent.indexOf('intel') !== -1) {
      return 'x86';
    }
    
    return 'unknown';
  },
  
  /**
   * Normalize architecture string to standard values
   * @param {string} arch - Raw architecture string
   * @returns {string} Normalized architecture: 'arm', 'x86', or 'unknown'
   */
  normalizeArchitecture: function(arch) {
    if (!arch || arch === 'unknown') {
      return 'unknown';
    }
    
    var normalized = arch.toLowerCase();
    
    // ARM variants
    if (normalized.indexOf('arm') !== -1 || 
        normalized.indexOf('aarch64') !== -1 || 
        normalized.indexOf('arm64') !== -1) {
      return 'arm';
    }
    
    // x86 variants
    if (normalized.indexOf('x86') !== -1 || 
        normalized.indexOf('x64') !== -1 || 
        normalized.indexOf('amd64') !== -1 || 
        normalized.indexOf('i386') !== -1 || 
        normalized.indexOf('i686') !== -1) {
      return 'x86';
    }
    
    return normalized;
  },
  
  /**
   * Check if the current architecture is ARM
   * @returns {Promise<boolean>} True if ARM architecture
   */
  isARM: function() {
    return FN.architectureDetector.detect()
      .then(function(arch) {
        return arch === 'arm';
      });
  },
  
  /**
   * Check if the current architecture is x86
   * @returns {Promise<boolean>} True if x86 architecture
   */
  isx86: function() {
    return FN.architectureDetector.detect()
      .then(function(arch) {
        return arch === 'x86';
      });
  },
  
  /**
   * Clear the cached architecture detection result
   */
  clearCache: function() {
    FN.architectureDetector.cache = null;
  }
};